export default __webpack_public_path__ + "static/media/rank-1.4ad6a103.webp";